import type { SnapshotReason } from './contracts';

export const AUTO_SNAPSHOT_RETENTION = 20;

export function shouldShowInHistory(reason: SnapshotReason, isPinned: boolean): boolean {
  return isPinned || reason !== 'conflict_protection';
}

export function isAutoRetentionCandidate(reason: SnapshotReason, isPinned: boolean): boolean {
  return reason === 'autosave_checkpoint' && !isPinned;
}

export function isRetentionProtected(reason: SnapshotReason, isPinned: boolean): boolean {
  return isPinned || reason !== 'autosave_checkpoint';
}

export function snapshotReasonLabel(reason: SnapshotReason): string {
  const labels: Record<SnapshotReason, string> = {
    autosave_checkpoint: 'Automatic checkpoint',
    conflict_protection: 'Conflict protection',
    manual_system: 'System checkpoint',
    manual_checkpoint: 'Saved version',
    before_restore: 'Before restore',
    after_restore: 'After restore',
    before_delete: 'Before delete',
    recovered_from_trash: 'Recovered from Trash',
    imported: 'Imported',
    system: 'System checkpoint',
  };
  return labels[reason];
}

